import { ACTIONS } from "../../common/constants";

const forbiddenReducer = function (state = false, action) {
    switch (action.type) {
        case ACTIONS.SET_FORBIDDEN:
            return action.data;
        default:
            return state;
    }
};

export default forbiddenReducer;
